// CacheKey af2b84b0ad577458c5ae3b8f8487ce17
//
// DO NOT MODIFY: This file was automatically generated by JsFromTranslations.
export default {
  nl: {
    date: {
      abbr_month_names: [
        null,
        "jan",
        "feb",
        "mrt",
        "apr",
        "mei",
        "jun",
        "jul",
        "aug",
        "sep",
        "okt",
        "nov",
        "dec"
      ],
      month_names: [
        null,
        "januari",
        "februari",
        "maart",
        "april",
        "mei",
        "juni",
        "juli",
        "augustus",
        "september",
        "oktober",
        "november",
        "december"
      ],
      order: [
        "day",
        "month",
        "year"
      ],
      day_names: [
        "zondag",
        "maandag",
        "dinsdag",
        "woensdag",
        "donderdag",
        "vrijdag",
        "zaterdag"
      ],
      formats: {
        default: "%d-%m-%Y",
        long: "%d %B %Y",
        short: "%d %b"
      }
    },
    time: {
      am: "AM",
      pm: "PM"
    },
    time_zones: {
      est: "Eastern Time",
      edt: "Eastern Time",
      cst: "Central Time",
      cdt: "Central Time",
      mst: "Mountain Time",
      mdt: "Mountain Time",
      pst: "Pacific Time",
      pdt: "Pacific Time",
      hst: "Hawaii–Aleutian Time",
      hdt: "Hawaii–Aleutian Time",
      akst: "Alaska Time",
      akdt: "Alaska Time"
    }
  }
}

